/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_errors_404_message = /** @type {(inputs: {}) => string} */ () => {
	return `Stránka, kterou jste požadovali, nebyla nalezena.`
};

const da_errors_404_message = /** @type {(inputs: {}) => string} */ () => {
	return `Siden du har anmodet om, blev ikke fundet.`
};

const de_errors_404_message = /** @type {(inputs: {}) => string} */ () => {
	return `Die angeforderte Seite wurde nicht gefunden.`
};

const en_errors_404_message = /** @type {(inputs: {}) => string} */ () => {
	return `The page you requested was not found.`
};

const es_errors_404_message = /** @type {(inputs: {}) => string} */ () => {
	return `La página que solicitaste no fue encontrada.`
};

const fr_errors_404_message = /** @type {(inputs: {}) => string} */ () => {
	return `La page que vous avez demandé n'a pas été trouvé.`
};

const hu_errors_404_message = /** @type {(inputs: {}) => string} */ () => {
	return `A keresett oldal nem található.`
};

const it_errors_404_message = /** @type {(inputs: {}) => string} */ () => {
	return `La pagina richiesta non è stata trovata.`
};

const nl_errors_404_message = /** @type {(inputs: {}) => string} */ () => {
	return `De pagina die je hebt opgevraagd is niet gevonden.`
};

const pl_errors_404_message = /** @type {(inputs: {}) => string} */ () => {
	return `Nie znaleziono żądanej strony.`
};

const pt_errors_404_message = /** @type {(inputs: {}) => string} */ () => {
	return `A página que você solicitou não foi encontrada.`
};

const sv_errors_404_message = /** @type {(inputs: {}) => string} */ () => {
	return `Sidan du begärde hittades inte.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const errors_404_message = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.errors_404_message(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("errors_404_message", locale)
	if (locale === "cs") return cs_errors_404_message(inputs)
	if (locale === "da") return da_errors_404_message(inputs)
	if (locale === "de") return de_errors_404_message(inputs)
	if (locale === "en") return en_errors_404_message(inputs)
	if (locale === "es") return es_errors_404_message(inputs)
	if (locale === "fr") return fr_errors_404_message(inputs)
	if (locale === "hu") return hu_errors_404_message(inputs)
	if (locale === "it") return it_errors_404_message(inputs)
	if (locale === "nl") return nl_errors_404_message(inputs)
	if (locale === "pl") return pl_errors_404_message(inputs)
	if (locale === "pt") return pt_errors_404_message(inputs)
	return sv_errors_404_message(inputs)
};
export { errors_404_message as "errors.404.message" }